import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Row, Col, Form, Input, Select } from 'antd';

import { FormInstance } from 'antd/es/form/Form';
import FloatingFormItem from '@/components/_common/FloatingFormItem';

interface FormValue {
  description: string;
  nature: string;
  hierarchy: string;
}

interface Props {
  form: FormInstance<FormValue>;
}

function PlanAccountReportForm({ form }: Props) {
  const intl = useIntl();

  const { Option } = Select;

  return (
    <Form form={form}>
      <FloatingFormItem
        label={intl.formatMessage({
          id: 'planAccounts.modal.report.form.description',
        })}
        name="description"
      >
        <Input />
      </FloatingFormItem>

      <Row gutter={[8, 8]}>
        <Col xs={24} sm={8} md={8}>
          <FloatingFormItem
            label={intl.formatMessage({
              id: 'planAccounts.modal.report.form.nature',
            })}
            name="destination"
          >
            <Select allowClear>
              <Option value="REVENUE">
                <FormattedMessage id="planAccounts.modal.report.form.nature.income" />
              </Option>
              <Option value="EXPENSE">
                <FormattedMessage id="planAccounts.modal.report.form.nature.expenses" />
              </Option>
            </Select>
          </FloatingFormItem>
        </Col>

        <Col xs={24} sm={8} md={8}>
          <FloatingFormItem
            label={intl.formatMessage({
              id: 'planAccounts.modal.report.form.hierarchy',
            })}
            name="hierarchy"
          >
            <Select allowClear>
              <Option value="SYNTETICS">
                <FormattedMessage id="planAccounts.modal.report.form.hierarchy.synthetic" />
              </Option>
              <Option value="ANALITICAL">
                <FormattedMessage id="planAccounts.modal.report.form.hierarchy.analytical" />
              </Option>
            </Select>
          </FloatingFormItem>
        </Col>

        <Col xs={24} sm={8} md={8}>
          <FloatingFormItem
            name="active"
            label={intl.formatMessage({
              id: 'commons.entity.situation',
            })}
          >
            <Select allowClear style={{ width: '100%' }}>
              <Select.Option value="true">
                <FormattedMessage id="commons.entity.active" />
              </Select.Option>
              <Select.Option value="false">
                <FormattedMessage id="commons.entity.inactive" />
              </Select.Option>
            </Select>
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
}

export default PlanAccountReportForm;
